import { useRef } from "react";
import styles from "./styles.module.css";
import profileIcon from "../../../assets/images/base/profile.png";
import Compressor from "compressorjs";

export const UserAvatar = ({ src, alt }) => {
  const inputFileRef = useRef();

  const blobToBase64 = (blob) => {
    const compressor = new Compressor(blob, {
      quality: 0.6,
      success(result) {
        const formData = new FormData();
        formData.append("image", result);
      },
    });
    return compressor;
  };

  const handleFileChange = async (event) => {
    const files = event.target.files;
    if (files?.length) {
      const file = files[0];
      blobToBase64(file);
      inputFileRef.current.value = "";
    }
  };
  return (
    <div className="relative">
      {/* <div
        className={styles.UserAvatar}
        onClick={() => inputFileRef.current.click()}
      > */}
      <div className={styles.UserAvatar}>
        <img
          src={src ? src : profileIcon}
          alt={alt ?? "avatar"}
          loading="lazy"
        />
        <input
          id="upload-file"
          type="file"
          accept=".png"
          multiple
          className="hidden"
          ref={inputFileRef}
          onChange={handleFileChange}
        />
        <div className={styles.EditLabel}>change</div>
      </div>
    </div>
  );
};
